import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SectionHeader from '../../base_section-header/component';
import Icon from '../../base_svg-icon/component';
import { Button } from 'audamatic-ui';

import componentToDOM from '../comp2dom';

/**
 * Base layout class.
 * All the layout components are extended from this class.
 * Alle the shared functionality can be part of this class.
 */
class Layout_base extends Component {
  constructor(props) {
    super(props);
    this._index = 0;
  }

  get components() {
    return this.props.components || [];
  }

  get shouldRender() {
    // Hide sections which should have products when they don't
    const mainComponent = this.components?.[0] || {};
    const isProductRow = ['grid', 'ankilerpromos', 'bestsellers'].includes(mainComponent['component-type']);
    if (isProductRow && (!mainComponent.products && !mainComponent.items)) {
      return false;
    }
    return true;
  }

  get linkExtraAttributes() {
    if (this.props.linkExtraAttributes && (this.props.linkExtraAttributes).constructor === Object) {
      return this.props.linkExtraAttributes;
    }
    return null;
  }

  get index() {
    return this._index++;
  }

  /**
   * Get the component from the component array with index 'index'
   * @param index
   * @returns {component}
   */
  componentDOM(index) {
    const i = (index !== undefined) ? index : this.index;
    return componentToDOM(this.components[index], i, this.drillProps);
  }
  /**
   * Render the header of the block
   *
   * @returns {DOM}
   */
  sectionHead() {
    const { title, name, subtitle, incentive, url, linkIcon, linkTitle, layout, store } = this.props;
    if (!title && !url) {
      return null;
    }

    return (
      <SectionHeader
        linkIcon={linkIcon}
        linkTitle={linkTitle}
        url={url}
        name={name}
        title={title}
        subtitle={subtitle}
        incentive={incentive}
        layout={layout}
        headerClasses="generic-header"
        store={store}
      />
    );
  }

  sectionFooter() {
    const { url, linkIcon = 'ico-arrow-circle-right', linkTitle } = this.props;

    if (!url || !linkTitle) {
      return null;
    }

    return (
      <div className="section-footer-link">
        <Button
          variant="link"
          size="large"
          iconLeft={<Icon name={linkIcon} size={150} />}
          onClick={() => window.location.href = url}
          {...this.linkExtraAttributes}
        >
          {linkTitle}
        </Button>
      </div>

    );
  }
}

Layout_base.propTypes = {
  components: PropTypes.array,
  linkIcon: PropTypes.string,
  store: PropTypes.object.isRequired,
  linkTitle: PropTypes.string,
  url: PropTypes.string,
  name: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  incentive: PropTypes.string,
  linkExtraAttributes: PropTypes.any,
  layout: PropTypes.any,
};

export default Layout_base;
